
<template>
  <div class="help-icon-container " v-click-outside="closeTooltip">
    <div class="help-content col-12" v-bind:class="[visibility ? 'slide-down' : 'slide-up']">
      <p class="help-content-text">
        <span v-html="this.info"></span>
      </p>
    </div>
    <i class="fa fa-info-circle help-icon" aria-hidden="true" @click="visibility = !visibility"></i>
  </div>
</template>

<script>
import { ClickOutside } from "@/directives/ClickOutside.js";
import htmlControlsMixin from "@/mixins/htmlControls";
export default {
  name: "tooltip",
  mixins: [htmlControlsMixin],
  props: ["helpText"],
  directives: {
    ClickOutside
  },
  data() {
    return {
      visibility: false,
      info: this.helpText
    };
  },
  methods: {
    closeTooltip: function () {
      if (this.visibility) {
        this.visibility = false;
      }
    }
  }
};
</script>
<style scoped>
.help-icon-container {
  padding: 0;
  z-index: 1000;
}

.help-icon {
  font-size: 1.45em;
  display: inline-block;
  position: absolute;
  padding-left: 0;
  padding-top: 0;
  cursor: pointer;
  top: 0px;
  right: -10px;
  margin: 0;
  height: 30px;
  line-height: 30px;
  background-color: none;
  color: #06397a;
}

.help-content {
  width: 252px;
  z-index: 500;
}

.help-content .help-content-text {
  border-radius: 6px;
  background: #06397a;
  color: #ffffff;
  padding: 8px;
  font-size: 0.9em;
}

.help-content:before {
  position: absolute;
  top: -7px;
  display: inline-block;
  border-right: 7px solid transparent; /*border-right: 8px solid #06397a; margin-top: 8px;*/ /*-- arrow left*/
  border-bottom: 8px solid #06397a;
  border-left: 7px solid transparent;
  content: "";
}

@media (min-width: 769px) {
  .slide-up,
  .slide-down {
    position: absolute;
    display: none;
    margin: 0;
    padding: 0;
  }
  .slide-down {
    display: block;
  }
  .help-content {
    top: 40px;
    right: -116px;
  }
  .help-content:before {
    right: 120px;
  }
}

@media (max-width: 768px) {
  .help-icon-container {
    overflow-y: hidden;
  }
  .help-content {
    width: 100%;
    position: relative;
    margin-top: 10px;
    top: 0;
    padding: 0;
    transition: 1s;
    left: 0;
  }
  .help-content:before {
    display: none;
  }
  .slide-up,
  .slide-down {
    position: relative;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.7s ease-in-out;
  }
  .slide-down {
    height: auto;
    max-height: 120px;
  }
}
</style>
